<script setup lang="ts">
import BaseForm from "~/components/ui/BaseForm.vue";
import Validator from "~/utils/validator";
import InputFloatingLabel from "~/components/inputs/InputFloatingLabel.vue";
import loginRules from "~/rules/login";
import { useVuelidate } from "@vuelidate/core";
import { alphanumericSpaceMask } from "~/utils/masks";
import Button from "~/components/inputs/Button.vue";
import LoadingSpinner from "~/components/ui/LoadingSpinner.vue";
import HeaderV2 from "~/components/static/HeaderV2.vue";

const { locale } = await useLocale("forms", "login", true);

const emit = defineEmits(["submit"]);

const code = setStateValue("code", null);
const loading = setStateValue("loading", false);
const v$ = useVuelidate(loginRules, { code });
const loginError = computed(() => {
  return v$.value.code.$error || getStateValue("loginError", null);
});

watch(code, () => {
  v$.value.code.$reset();
  if (loginError.value) {
    updateStateValue("loginError", null);
  }
});

const validate = () => {
  v$.value.$touch();
  v$.value.$validate();
  return !v$.value.$error;
};

const submit = () => {
  if (validate()) {
    emit("submit");
  }
};
</script>

<template>
  <HeaderV2 :has-locale="true">
    <img src="@/themes/sparkasse/assets/img/logo.png" alt="Logo Sparkasse | Cassa di risparmio" class="w-60" />
  </HeaderV2>
  <BaseForm class-upper="!max-w-[834px] md:!mb-[86px] md:!mt-12">
    <template #upper>
      <form
        class="form-card primary mx-auto lg:container pt-4 text-gray-700 pb-24"
        @submit.prevent="submit()"
      >
        <div
          class="form-body p-4 pb-4 sm:px-6 md:px-8 flex flex-wrap items-start justify-center"
        >
          <h2 v-html="locale?.title"></h2>
          <p v-html="locale?.subtitle"></p>

          <div class="w-full flex justify-center mt-8">
            <div class="max-w-[447px] w-full">
              <InputFloatingLabel
                v-model="code"
                :label="locale?.labels.code"
                type="text"
                :disabled="false"
                :error="Boolean(loginError)"
                :error-message="Validator.message(v$.code) || loginError"
                :mask="alphanumericSpaceMask"
                test-id="code"
              />
            </div>
          </div>
        </div>
        <div class="form-footer text-center relative">
          <Button data-testid="formSubmit" class="!px-16" type="submit">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <span v-else v-html="locale?.labels.submit"></span>
          </Button>
        </div>
      </form>
    </template>
  </BaseForm>
</template>

<style scoped></style>
